import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { MoreIcon } from '@mentimeter/ragnar-visuals';
import { useTranslations } from 'next-intl';
import { forwardRef } from 'react';

interface Props {
  id: string;
  alwaysVisible: boolean;
}

export const OverviewListItemDropdownMenuIcon = forwardRef<HTMLElement, Props>(
  ({ id, alwaysVisible, ...rest }, ref) => {
    const t = useTranslations('creation.editor_overview');

    return (
      <Clickable
        aria-hidden
        ref={ref}
        aria-label={t('open_context_menu_a11y')}
        data-testid={`overview-actions-${id}`}
        id={`overview-actions-${id}`}
        p={alwaysVisible ? 0 : 1}
        extend={({ theme }) => ({
          opacity: alwaysVisible ? 1 : 0,
          transition: 'opacity 0.2s',
          '&:focus': {
            opacity: 1,
          },
          '&[aria-expanded=true]': {
            opacity: 1,
          },
          '&:hover': {
            backgroundColor: theme.colors.neutral,
          },
        })}
        {...rest}
      >
        <MoreIcon size={alwaysVisible ? 1 : 0} color="onNeutral" />
      </Clickable>
    );
  },
);
